module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("61Nfr"))).then(() => parcelRequire('1iHdE'));